import { forwardRef, useEffect, useState } from "react";
import { StringInputProps } from "./Common";
import InputBox from "./InputBox";

const StringInput = forwardRef<HTMLInputElement, StringInputProps>((props: StringInputProps, ref) => {
  const [hasValidationErrors, setHasValidationErrors] = useState(false);

  const hasErrors = (value: string | null) => {
    if (!props.required) {
      return false;
    }

    return !value?.trim() || (!!props.max && value.length > props.max) || (!!props.min && value.length < props.min);
  }

  useEffect(() => {
    setHasValidationErrors(hasErrors(props.value));
  }, [props.value]);

  return <InputBox
    ref={ref}
    type="text"
    {...props}
    onKeyDown={(event) => {
      if (event.key === "Enter" && props.onEnterPress) {
        props.onEnterPress();
      }
    }}
    onChange={(event) => {
      props.onChange(event.target.value);
    }}
    hasValidationErrors={hasValidationErrors} />
});

export default StringInput;